export default "__VITE_ASSET__DxmIVAzl__"